import { ProjectCard } from "@components/common/project-card/project-card";
import { CardSkeleton } from "@components/common/skeleton-loading/card-skeleton";
import { VirtualizedGrid } from "@components/virtualized/virtualized-grid";
import { PaginatedProjects } from "@custom-types/project-types";
import { Box } from "@mui/material";

type Props = Pick<
  PaginatedProjects,
  "companyId" | "projects" | "sortBy" | "loadMoreProjects"
> & {
  /** Flag whether it is loading some content  */
  isLoading: boolean;
};

/**
 * The projects tab listing all the active or archived projects (depending on the props) in the company
 */
export function ProjectsTiles({
  isLoading,
  projects,
  companyId,
  loadMoreProjects,
  sortBy,
}: Props): JSX.Element {
  return (
    <Box padding="0.063rem">
      <VirtualizedGrid
        // The `key` here forces React to remount the grid whenever `sortBy` changes.
        // This ensures that the scroll position resets and the grid re-renders from the first item
        key={sortBy}
        items={projects}
        isLoading={isLoading}
        loadMoreItems={loadMoreProjects}
        renderSkeletonItem={(i) => (
          <CardSkeleton key={`skeleton-project-${i}`} type="project" />
        )}
        renderItem={(project) => (
          <ProjectCard
            key={project.id}
            project={project}
            companyId={companyId}
            numberOfProjects={projects.length}
            sortBy={sortBy}
          />
        )}
      />
    </Box>
  );
}
